export default [
	{
		path: '/',
		component: () => import('views/processos/index' /* webpackChunkName: 'home' */),
		props: () => ({ showComunicado: false })
	},	
	{
		path: '/processos/:anoProcesso/:nrProcesso',
		component: () => import('views/processos/index' /* webpackChunkName: 'processos */),
		props: () => ({ showComunicado: false })
	},
	{
		path: '/processos',
		component: () => import('views/processos/index' /* webpackChunkName: 'processos */),
		props: () => ({ showComunicado: true })
	},
	{
		path: '/comunicados',
		component: () => import('views/processos/index' /* webpackChunkName: 'processos */),
		props: () => ({ showComunicado: true })
	},
	{
		path: '*',
		component: () => import('views/commons/page404' /* webpackChunkName: 'page404' */)
	}

];


// WEBPACK FOOTER //
// ./application/routes.js